import React from 'react';
import { useSelector } from 'react-redux';
import { Marker, MarkerClusterer, InfoWindow } from '@react-google-maps/api';
import { setSelectedRivalsMarker } from '../../../store/requests/zone';

const ViewRivalsByLocationWithClusterer = (props) => {
  const rivalsByLocationState =
    useSelector((state) => state?.zone?.rivalsByLocation) ?? null;

  return (
    <>
      {rivalsByLocationState?.rivalsByLocationMarkers.length > 0 && (
        <MarkerClusterer maxZoom={15}>
          {(clusterer) =>
            rivalsByLocationState?.rivalsByLocationMarkers.map(
              (marker, index) => (
                <Marker
                  key={index}
                  position={marker.position}
                  icon={marker.icon}
                  title={marker.title}
                  onClick={() => setSelectedRivalsMarker(marker)}
                  clusterer={clusterer}
                />
              ),
            )
          }
        </MarkerClusterer>
      )}
      {rivalsByLocationState?.selectedRivalsMarker && (
        <InfoWindow
          style={{ maxWidth: '150px', maxHeight: '100px' }}
          position={rivalsByLocationState?.selectedRivalsMarker?.position}
          onCloseClick={() => setSelectedRivalsMarker(null)}
        >
          <div>{rivalsByLocationState?.selectedRivalsMarker?.title}</div>
        </InfoWindow>
      )}
    </>
  );
};

export default ViewRivalsByLocationWithClusterer;
